import React from 'react';
import { sellTypeSelect } from '../libs/utils/Const';

class SeriesAndConsecutiveModal extends React.Component {

    render() {
        const {
            newOrderModel,
            eventOnclick,
            message,
            button1,
            button2,
            eventOnclick2,
            shadow,
            onSelectSeries,
            sellType,
        } = this.props;
        const vta = sellTypeSelect.find(vta => vta.value == sellType)
        const normalizedSeries = normalizeSeries(newOrderModel?.currSeries ?? []);

        return (
            <div className="modal fade" id="seriesSelection" tabIndex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content" style={shadow ? { boxShadow: "rgb(1 1 1 / 30%) 1px 1px 10px" } : { boxShadow: "none" }}>

                        <div className="modal-header">
                            <h5 className="modal-title" style={{ width: "100%", textAlign: "center" }}>
                                Seleccione la serie {newOrderModel.U_BPP_MDTDName ? `para ${newOrderModel.U_BPP_MDTDName}` : ""}
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={eventOnclick2}>
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <p className="text-center">{`Venta ${vta?.prefix ?? ''} ${vta?.tipoVta ?? ''}`}</p>
                            <p>{message}</p>

                            <table className="table table-sm table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "center" }}>Serie</th>
                                        <th style={{ textAlign: "center" }}>Default</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {normalizedSeries.map((s, idx) => (
                                        <tr key={idx}>
                                            <td style={{ textAlign: "center" }}>{s.value}</td>
                                            <td style={{ textAlign: "center" }}>
                                                <input
                                                    type="radio"
                                                    name="seriesSelect"
                                                    checked={newOrderModel.U_BPP_MDSD == s.value}
                                                    onChange={() => onSelectSeries(s.value)}
                                                    style={{ width: 12, height: 12 }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>

                        <div className="modal-footer">
                            <button type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                                onClick={eventOnclick2}>
                                {button2 ?? "Cancelar"}
                            </button>

                            {newOrderModel.U_BPP_MDSD && <button type="button"
                                className="btn btn-primary"
                                data-dismiss="modal"
                                onClick={eventOnclick}>
                                {button1 ?? "Aceptar"}
                            </button>}
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

function normalizeSeries(seriesList = []) {
    const cleaned = seriesList
        .filter(s => s && String(s).trim() !== "")
        .map(s => String(s).trim());

    const idxDefault = cleaned.findIndex(s => s.includes("~D"));

    let normalized = cleaned.map(s => ({
        value: s.replace("~D", "").trim(),
        default: s.includes("~D")
    }));

    if (idxDefault === -1 && normalized.length > 0) {
        normalized = normalized.map((s, i) => ({ ...s, default: i === 0 }));
    }

    return normalized;
}

export default SeriesAndConsecutiveModal;
